/**
 * Keeps the active pack in line with the live-config flag `curriculumV2` (docs/CURRICULUM-V2.md §E.3):
 * on start and whenever the resolved config changes, swap the pack, migrate every profile once (v2:
 * frontier + grandfathered "New!" nodes, frozen per profile) and remount the screens.
 */
import { useApp } from '../state/store';
import { migrateForCurriculum, setCurriculumAsync } from './content';
import { useContentState } from './contentPack';

let queue: Promise<void> = Promise.resolve();
function apply(on: boolean): Promise<void> {
  queue = queue.then(async () => {
    if (!(await setCurriculumAsync(on))) return;
    const st = useApp.getState();
    for (const id of Object.keys(st.progress)) {
      const p = st.progress[id]!;
      const next = migrateForCurriculum(p);
      if (next !== p) st.updateProgress(id, () => next);
    }
    useContentState.setState((s) => ({ rev: s.rev + 1 }));
  });
  return queue;
}

let started: Promise<void> | null = null;
/** Resolves once the first swap (+ migration of the persisted progress) is done — awaited before the first render. */
export function startCurriculumSync(): Promise<void> {
  if (started) return started;
  started = apply(!!useApp.getState().config.curriculumV2);
  useApp.subscribe((s, prev) => {
    if (s.config.curriculumV2 !== prev.config.curriculumV2) void apply(!!s.config.curriculumV2);
  });
  return started;
}
